import React from 'react';
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';
import { useTranslation } from 'react-i18next';

interface StatItemProps {
  number: string;
  label: string;
}

const StatItem: React.FC<StatItemProps> = ({ number, label }) => (
  <div className="text-center mb-4 mb-md-0">
    <h2 className="display-4 fw-bold mb-2">{number}</h2>
    <p className="text-muted mb-0">{label}</p>
  </div>
);

const Stats = () => {
  const { t } = useTranslation();

  const stats = [
    {
      number: t('stats.projects.number'),
      label: t('stats.projects.label')
    },
    {
      number: t('stats.satisfaction.number'),
      label: t('stats.satisfaction.label')
    },
    {
      number: t('stats.experience.number'),
      label: t('stats.experience.label')
    }
  ];

  return (
    <div className="container my-5 py-5">
      <MDBRow className='row-cols-1 row-cols-md-3 row-cols-lg-3'>
        {stats.map((stat, index) => (
          <MDBCol key={index}>
            <StatItem number={stat.number} label={stat.label} />
          </MDBCol>
        ))}
      </MDBRow>
    </div>
  );
};

export default Stats; 